import { Box, Heading, Text } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";

export default function Hero({
  image = ["/bowling-photo.jpg"],
  height = { base: "400px", md: "400px", lg: "600px" },
}) {
  const { t } = useTranslation();

  return (
    <Box
      w="100%"
      h={height}
      position="relative"
      bg={`url(${image})`}
      bgSize="cover"
      bgPos="center"
      bgRepeat="no-repeat"
      aria-label="Hero section"
      role="region"
    >
      {/* Overlay + περιεχόμενο */}
      <Box
        w="100%"
        h="100%"
        bgGradient="linear(to-r, blackAlpha.700, blackAlpha.400)"
        display="flex"
        flexDir="column"
        alignItems="center"
        justifyContent="center"
        textAlign="center"
        color="white"
        px={4}
      >
        <Heading fontSize={{ base: "3xl", md: "5xl" }} mb={3}>
          {t("hero_title")}
        </Heading>
        <Text mb={6} fontSize={{ base: "sm", md: "lg" }}>
          {t("hero_subtitle")}
        </Text>
      </Box>
    </Box>
  );
}
